// Web Agora facade. The app imports Agora through this module so the native
// build can swap in react-native-agora (see agora.native.ts). On web this is a
// transparent re-export of agora-rtc-react — behavior is unchanged.
import AgoraRTC from "agora-rtc-react";

export * from "agora-rtc-react";
export default AgoraRTC;
